import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 6H3c-.552 0-1 .449-1 1.002v10.02c0 .553.448 1.002 1 1.002h18c.552 0 1-.449 1-1.002V7.002C22 6.449 21.552 6 21 6M3.5 16.52v-2.003c1.105 0 2 .897 2 2.004zm0-7.013V7.503h2a2 2 0 0 1-2 2.004m8.5 5.51c-1.38 0-2.5-1.345-2.5-3.005s1.12-3.006 2.5-3.006 2.5 1.346 2.5 3.006-1.12 3.006-2.5 3.006m8.5 1.504h-2c0-1.107.895-2.004 2-2.004zm0-7.014c-1.105 0-2-.897-2-2.004h2z"
    }, null, -1)
  ])))
}
export default { render: render }